const warn = (s: string) => {
  console.warn("[react-gtm-module]", s);
};

export default warn;
